import { useEffect, useState } from "react"
import { ShowAnimeCard } from "../components/ShowAnimeButton"
import { getRecommandationsByAnnee } from "../api"
export function RecommandationsAnneePage() {

    const [animesRecommandated, setAnimesRecommandated] = useState([])
    async function handleGenerate() {
        let fromSlider = document.querySelector('#fromSlider');
        let toSlider = document.querySelector('#toSlider');
        if( document.getElementById("button_generer").textContent === "Chargement...") return;
        document.getElementById("button_generer").textContent = "Chargement..."
        const data = await getRecommandationsByAnnee(fromSlider.value, toSlider.value)
        document.getElementById("button_generer").textContent = "Générer"
        document.querySelector('#fromSlider').value = fromSlider.value
        document.querySelector('#toSlider').value = toSlider.value
        return setAnimesRecommandated(data)
    }






    SlideBar()


    return (
        <div className="text-white">
            <h1 className="text-3xl text-center font-semibold mb-4 mt-10">Page de Recommandation de FILMS par Année</h1>
            {/* <hr className="mx-5" /> */}
            <h3 className="text-center my-2">Nous pouvons vous recommander des films a partir de leur année de sortie</h3>


            <div className="mt-10 w-full justify-center items-center flex flex-wrap flex-row gap-4">
                {/* {genres.map(g => {
                    return (
                        ShowGenreButton(g, anneeSelected, setAnneeSelected)
                    )
                })} */}
                {/* <input min="1920" max="2023" type="range" className="rounded-lg overflow-hidden appearance-none bg-gray-800 h-3 w-[340px]" /> */}
                <div className="container my-10 range_container w-full">
                    <div className="sliders_control">
                        <input id="fromSlider" type="range" value="1930" min="1920" max="2023" />
                        <input id="toSlider" type="range" value="1950" min="1920" max="2023" />
                    </div>
                    <div className="w-full flex flex-row flex-wrap justify-between">
                        <div className="">
                            <div className="">Min</div>
                            <input className="bg-gray-800 p-2 rounded-lg" type="number" id="fromInput" value="1930" min="1920" max="2023" />
                        </div>
                        <div className="w-[100px]">
                            <div className="">Max</div>
                            <input className="bg-gray-800 p-2 rounded-lg" type="number" id="toInput" value="1950" min="1920" max="2023" />
                        </div>
                    </div>
                </div>
                <div className="flex flex-col gap-2 items-center">
                    <p>- Les curseurs sont rénitialisés à chaque génération</p>
                    <p>- Un trop grand intervalle risque de faire crash votre navigateur (20 ans max)</p>
                </div>
            </div>
            <div className="mt-10 flex justify-center">
                <button onClick={() => handleGenerate()} id="button_generer" className="py-2 px-10 bg-orange-500 rounded-lg">Générer</button>
            </div>

            <div className="mt-10 flex flex-wrap flex-row gap-8 justify-center">
                {animesRecommandated.length > 0 ?
                    <>
                        {animesRecommandated.map((anime, i) => {
                            return (
                                ShowAnimeCard(anime, i)
                            )
                        })}
                    </>
                    : null
                }
            </div>
        </div>
    )
}

function SlideBar() {
    useEffect(() => {
        console.log(1)
        function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
            const [from, to] = getParsed(fromInput, toInput)

            fillSlider(fromInput, toInput, '#C6C6C6', '#25daa5', controlSlider)
            if (from > to) {
                fromSlider.value = to
                fromInput.value = to
            } else {
                fromSlider.value = from
                fromInput.value = from
            }
        }

        function controlToInput(toSlider, fromInput, toInput, controlSlider) {
            const [from, to] = getParsed(fromInput, toInput)
            fillSlider(fromInput, toInput, '#C6C6C6', '#25daa5', controlSlider)
            setToggleAccessible(toInput)
            if (from <= to) {
                toSlider.value = to
                toInput.value = to
            } else {
                toSlider.value = from
                toInput.value = from
            }
        }

        function controlFromSlider(fromSlider, toSlider, fromInput) {
            const [from, to] = getParsed(fromSlider, toSlider)
            fillSlider(fromSlider, toSlider, '#C6C6C6', '#25daa5', toSlider)
            if (from > to) {
                fromSlider.value = to
                fromInput.value = to
            } else {
                fromInput.value = from
                fromSlider.value = from
            }
        }

        function controlToSlider(fromSlider, toSlider, toInput) {
            const [from, to] = getParsed(fromSlider, toSlider)
            fillSlider(fromSlider, toSlider, '#C6C6C6', '#25daa5', toSlider)
            setToggleAccessible(toSlider)
            if (from <= to) {
                toSlider.value = to
                toInput.value = to
            } else {
                toInput.value = from
                toSlider.value = from
            }
        }

        function getParsed(currentFrom, currentTo) {
            const from = parseInt(currentFrom.value, 10)
            const to = parseInt(currentTo.value, 10)
            return [from, to]
        }

        function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
            const rangeDistance = to.max - to.min
            const fromPosition = from.value - to.min
            const toPosition = to.value - to.min
            controlSlider.style.background = `linear-gradient(
          to right,
          ${sliderColor} 0%,
          ${sliderColor} ${(fromPosition) / (rangeDistance) * 100}%,
          ${rangeColor} ${((fromPosition) / (rangeDistance)) * 100}%,
          ${rangeColor} ${(toPosition) / (rangeDistance) * 100}%, 
          ${sliderColor} ${(toPosition) / (rangeDistance) * 100}%, 
          ${sliderColor} 100%)`
        }

        function setToggleAccessible(currentTarget) {
            const toSlider = document.querySelector('#toSlider')
            if (Number(currentTarget.value) <= 0) {
                toSlider.style.zIndex = 2
            } else {
                toSlider.style.zIndex = 0
            }
        }
        let fromSlider = document.querySelector('#fromSlider')
        let toSlider = document.querySelector('#toSlider')
        let fromInput = document.querySelector('#fromInput')
        let toInput = document.querySelector('#toInput')
        fillSlider(fromSlider, toSlider, '#C6C6C6', '#25daa5', toSlider)
        setToggleAccessible(toSlider)
        fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromInput)
        toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput)
        fromInput.oninput = () => controlFromInput(fromSlider, fromInput, toInput, toSlider)
        toInput.oninput = () => controlToInput(toSlider, fromInput, toInput, toSlider)
    }, [])
}
